import { useCallback, useState } from 'react';
import type { UnifiedAsset } from '@/hooks/useAssetsUnified';

export function useAssetsSelection(initial: string[] = []) {
  const [selectedAssets, setSelectedAssets] = useState<string[]>(initial);

  const selectAllFiltered = useCallback((assets: UnifiedAsset[]) => {
    setSelectedAssets((assets || []).map(a => a.id));
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedAssets([]);
  }, []);

  return {
    selectedAssets,
    setSelectedAssets,
    selectAllFiltered,
    clearSelection,
  };
}
